import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                if (obj.customQuery)
                {
                    str += str ? '&' : '?';
                    str += obj.customQuery;
                }
                const url = `/${obj.tablename}${str}`;
                // console.log('crud : ',url); 
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    findcoa(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.get(`/kodeperk/?kodeacc=${obj.kodeacc}`);
                const { list } = data;
                resolve(list[0]);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    insert(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // delete data.materials;
                const resp = await axios.post(`/${obj.tablename}`, obj.data);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    update(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // delete data.materials;
                const resp = await axios.put(`/${obj.tablename}/${obj.key}`, obj.data);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/${obj.tablename}/${obj.key}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/${obj.tablename}/${obj.key}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }    
};